__turbopack_context__.v({
  "benefits": "card-module-scss-module__cW-IHq__benefits",
  "benefits-group": "card-module-scss-module__cW-IHq__benefits-group",
  "benefits-row": "card-module-scss-module__cW-IHq__benefits-row",
  "benefits-row-berry": "card-module-scss-module__cW-IHq__benefits-row-berry",
  "benefits-row-moss": "card-module-scss-module__cW-IHq__benefits-row-moss",
  "benefits-row-placeholder": "card-module-scss-module__cW-IHq__benefits-row-placeholder",
  "benefits-row-smoke": "card-module-scss-module__cW-IHq__benefits-row-smoke",
  "button": "card-module-scss-module__cW-IHq__button",
  "card-label": "card-module-scss-module__cW-IHq__card-label",
  "chip": "card-module-scss-module__cW-IHq__chip",
  "content-wrapper": "card-module-scss-module__cW-IHq__content-wrapper",
  "placeholder": "card-module-scss-module__cW-IHq__placeholder",
  "price": "card-module-scss-module__cW-IHq__price",
  "price-breakdown": "card-module-scss-module__cW-IHq__price-breakdown",
  "price-breakdown-row-placeholder": "card-module-scss-module__cW-IHq__price-breakdown-row-placeholder",
  "price-headline-placeholder": "card-module-scss-module__cW-IHq__price-headline-placeholder",
  "price-value": "card-module-scss-module__cW-IHq__price-value",
  "product-name": "card-module-scss-module__cW-IHq__product-name",
  "radio": "card-module-scss-module__cW-IHq__radio",
  "wrapper": "card-module-scss-module__cW-IHq__wrapper",
});
